import { Injectable, inject } from '@angular/core';
import { UserAuthenticationService } from '../user-authentication/user-authentication.service';

export enum SessionStorageKeyEnum {
	SelfServiceCatalogLoggedUser = 'BT_ADMINAPP_LOGGEDUSERJWT_##CATALOGID##',
	TeamsAppMessageContent = 'BT_ADMINAPP_TEAMSAPPS_MESSAGEDATA',
	SPCatalogMessageContent = 'BT_ADMINAPP_SPCATALOG_MESSAGEDATA',
	PublicApproval = 'BT_ADMINAPP_PUBLICAPPROVAL',
	ActivityLogsComponent = 'BT_ADMINAPP_ACTIVITYLOGSCOMPONENT',
	QualifyingQuestionRemindMeLater = 'BT_ADMINAPP_QUALIFYINGQUESTION_REMINDMELATER_##USERID##',
}

@Injectable({
	providedIn: 'root'
})

export class SessionStorageService {
	private userAuthenticationService = inject(UserAuthenticationService);


	/**
   * Remove item from session storage by key
   * @param key Key of item
   */
	public get(key: string) {
    const item = sessionStorage.getItem(key);
		return item ? JSON.parse(item) : '';
	}

  /**
   * Save item to session storage
   * @param key Key of item
   * @param value Value of item
   */
	public save<T>(key: string, value: T) {
		if (key && value) {
		    sessionStorage.setItem(key, JSON.stringify(value));
		}
	}

  /**
   * Remove item from session storage
   * @param key Key of item
   */
	public remove(key: string) {
		if (key) {
		    sessionStorage.removeItem(key);
		}
	}

  /**
   * Clear the session storage
   */
	public clear() {
		sessionStorage.clear();
	}


	/**Get the session storage key from the Enum to have consistency */
	public getSessionStorageKey(key: SessionStorageKeyEnum) {
		return key.replace("##USERID##", this.userAuthenticationService.getAuthenticatedUserId());
	}
}
